<template>
  <f7-page ptr @ptr:refresh="refreshData" @page:reinit="getList">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        back-link-url="/home">
      </f7-nav-left>
      <f7-nav-title>通知</f7-nav-title>
    </f7-navbar>
    <div class="has-content">
      <div
        style="text-align: center;"
        v-if="noticeList.length === 0">
        暂无数据
      </div>
      <div v-else>
        <div class="list media-list">
          <ul>
            <li v-for="item in noticeList" :key="item.id">
              <a
                href="#"
                class="item-link item-content"
                style="padding-top: 0.5rem;"
                @click="showNotice(item)">
                <div class="item-media" style="padding-top: 0rem;">
                  <img
                    :src="`${imageUrl}?attachmentId=${item.headImage}`"
                    height="40"
                    width="40"
                    v-if="item.headImage"/>
                  <img
                    src="@/assets/img/avatar.png"
                    height="40"
                    width="40"
                    v-else/>
                </div>
                <div class="item-inner">
                  <div class="item-title-row">
                    <div class="item-title">{{ item.inviteUserName }}</div>
                    <div class="item-after" style="font-size: 0.9rem;">
                      {{ item.createTime | formatDateValue }}
                    </div>
                  </div>
                  <div
                    class="item-text notice-item-text"
                    style="min-height: 35px; max-height: 35px;">
                    <div class="notice-text">
                      {{ item.content }}
                    </div>
                    <div v-if="item.result !=='0' && item.result !=='1'">
                      <img src="@/assets/img/weichuli.png" height="25px" />
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <f7-popup :opened="noticeOpened" @popup:closed="noticeOpened = false">
      <notice :notice="notice" :opened.sync="noticeOpened"></notice>
    </f7-popup>
  </f7-page>
</template>
<script>
import { dateFormat } from '@/util/dateUtils';
import { imageView } from '@/api/common';
import { getNoticeList } from '@/api/notice';
import Notice from '@/pages/notice/info';

export default {
  components: {
    Notice,
  },
  data() {
    return {
      imageUrl: imageView,
      noticeList: [],
      noticeOpened: false,
      notice: {},
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    noticeOpened(newVal) {
      if (!newVal) {
        this.notice = {};
        this.getList();
      }
    },
  },
  filters: {
    formatDateValue: value => dateFormat(value),
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getList()]).then(() => done());
    },
    getList() {
      getNoticeList().then((result) => {
        if (result.code === 0) {
          this.noticeList = result.data || [];
        }
      });
    },
    showNotice(notice) {
      this.notice = notice;
      this.noticeOpened = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .notice-item-text {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .notice-text {
    flex: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.8rem;
    // display: -webkit-box;
    // -webkit-line-clamp: 2;
    // -webkit-box-orient: vertical;
  }

</style>



// WEBPACK FOOTER //
// src/pages/notice/list.vue